import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { assignTestId } from '@common/infra/tests/assign-test-id';
import NavigationLink from '@common/navigation/navigation-link';
import { Badge } from '@common/badge';
import styles from '../users-admin-page.css';
export function UsersTableUsername({ id, username, isActive }) {
    return (_jsxs("div", { className: styles.usernameBadge, children: [_jsx(NavigationLink, { href: `/users/${id}`, ...assignTestId('username', 'user-link'), children: username }), isActive ? null : (_jsx(Badge, { variant: Badge.variant.Filled, color: Badge.color.Disabled, size: Badge.size.Md, children: "Deactivated" }))] }));
}
